/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Russian
export default {
  'embedded-confluence-common.src.content.empty-state-description':
    'Мы искали повсюду, но такой страницы не существует. Возможно, она была удалена. Если, конечно, URL-адрес указан верно 😉',
  'embedded-confluence-common.src.content.empty-state-header': 'Не удалось найти то, что вы ищете',
  'embedded.confluence.already-logged-in-paragraph': 'Вы уже вошли в систему? Обновите страницу.',
  'embedded.confluence.footer.hover.text': 'Просмотр в Confluence',
  'embedded.confluence.footer.prefix': 'При поддержке',
  'embedded.confluence.generic-error-page.login-to-confluence-button': 'Войти в Confluence',
  'embedded.confluence.login-page.login-button': 'Войти в Confluence',
  'embedded.confluence.login-page.login-button.aria-label': 'Кнопка входа',
  'embedded.confluence.login-page.login-text': 'Для просмотра этой страницы необходимо войти в систему',
  'embedded.confluence.login-page.refresh-page-banner':
    'После входа в систему страница должна автоматически обновиться. Если этого не произойдет, нажмите здесь, чтобы ее обновить',
  'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Обновить страницу',
  'embedded.confluence.need-to-log-in-paragraph': 'Для просмотра этой страницы необходимо войти в систему',
  'embedded.confluence.still-having-trouble-paragraph':
    'Проблема не исчезла? Убедитесь, что сторонние файлы cookie включены, или {link}',
  'embedded.confluence.troubleshooting-link-text': 'обратитесь к руководству по устранению неполадок.',
  'embedded.confluence.troubleshooting-link.aria-label': 'ссылка на руководство по устранению неполадок',
};
